import { parse } from 'node-html-parser';

import { GROUP_DOMAINS } from '../constants/Lgpd';

/**
 * Normaliza um domínio ou URL removendo o protocolo para comparação
 * @param {string} url - URL ou domínio a ser normalizado
 * @returns {string} URL normalizada sem protocolo
 */
const normalizeDomain = (url) => {
  if (!url) return '';
  // Remove http://, https://, // do início
  return url.replace(/^(https?:)?\/\//, '');
};

const domainAllowed = (group, src, groupDomains = GROUP_DOMAINS) => {
  if (!src) return false;
  const normalizedSrc = normalizeDomain(src);
  return groupDomains[group].some((domain) => {
    const normalizedDomain = normalizeDomain(domain);
    return normalizedSrc.includes(normalizedDomain);
  });
};

const hiddenSrc = (
  cookie,
  key,
  src,
  isClient,
  groupDomains = GROUP_DOMAINS,
) => {
  // Verifica se o domínio do src está na lista 'noConsentUrls', retornando 'false' para não esconder
  if (domainAllowed('noConsentUrls', src, groupDomains)) {
    return false;
  }

  // Se não estiver no lado servidor, devemos esconder o src
  if (!isClient) {
    return true;
  }

  // Se o usuário aceitou o cookie e o domínio está na lista branca, não escondemos o src
  const shouldHide = !(cookie && domainAllowed(key, src, groupDomains));

  return shouldHide;
};

export const srcAllowed = (
  src,
  performanceCookies,
  thirdPartyCookies,
  isClient,
  groupDomains = GROUP_DOMAINS,
) => {
  let hiddenSrcPerformance = true;
  const hiddenSrcThirdParty = hiddenSrc(
    thirdPartyCookies,
    'thirdParty',
    src,
    isClient,
    groupDomains,
  );
  if (!hiddenSrcThirdParty) {
    hiddenSrcPerformance = hiddenSrc(
      performanceCookies,
      'performance',
      src,
      isClient,
      groupDomains,
    );
  }
  if (src && hiddenSrcThirdParty && hiddenSrcPerformance) {
    return false;
  }
  return true;
};

export const blockHTML = (
  html,
  performanceCookies,
  thirdPartyCookies,
  isClient,
  groupDomains = GROUP_DOMAINS,
  { allowScriptContent = false } = {},
) => {
  let alert = false;
  let blocked = false;
  const tags = ['iframe', 'script'];
  if (!tags.some((tag) => html.includes(`<${tag}`))) {
    return { html: html, alert: alert, blocked: blocked };
  }
  const root = parse(html);
  tags.forEach((tag) => {
    const elements = root.getElementsByTagName(tag);
    elements.forEach((element) => {
      if (tag === 'script' && !allowScriptContent) {
        element.innerHTML = ''; // Remove o conteúdo da tag script
      }
      const src = element.getAttribute('src');
      const srcInNoConsentUrls = domainAllowed(
        'noConsentUrls',
        src,
        groupDomains,
      );
      const srcInThirdPartyCookies = domainAllowed(
        'thirdParty',
        src,
        groupDomains,
      );
      const srcInPerformanceCookies = domainAllowed(
        'performance',
        src,
        groupDomains,
      );
      if (!srcInNoConsentUrls) {
        if (srcInThirdPartyCookies || srcInPerformanceCookies) {
          alert = true;
        } else if (src) {
          blocked = true;
        }
      }
      let allowed = srcAllowed(
        src,
        performanceCookies,
        thirdPartyCookies,
        isClient,
        groupDomains,
      );
      if (!allowed) {
        element.removeAttribute('src');
        element.setAttribute('src-data', src);
      } else {
        element.removeAttribute('src-data');
        // Só redefine o atributo src se o elemento realmente possuía um.
        // Scripts inline (sem src) não devem receber src="null".
        if (src) {
          element.setAttribute('src', src);
        }
      }
    });
  });
  return { html: root.toString(), alert: alert, blocked: blocked };
};
